import { render, staticRenderFns } from "./Acao.vue?vue&type=template&id=5e801d66"
import script from "./Acao.vue?vue&type=script&lang=js"
export * from "./Acao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports